module.exports = __webpack_public_path__ + "static/media/10_The broken mirror_IN.fc994062.txt";